module.exports = __webpack_public_path__ + "static/media/tier-check.2c4a629f.svg";